import ResponsiveDropdown from './ResponsiveDropdown.component';

export default ResponsiveDropdown;
